// Bunkering: what the database made for one bunkering (sql/consistency.sql hc_bunkering_links), in the same words for the
// Bunkering page and the AI. b = the saved bunkerings row (with its link columns), lineLabel = budget line name if known.
const addDays = (d, n) => { const x = new Date(String(d).slice(0, 10) + 'T12:00:00Z'); x.setUTCDate(x.getUTCDate() + n); return x.toISOString().slice(0, 10) }
const num = v => Number(v).toLocaleString('en-GB')

// One fuel name everywhere (page, AI, Oil Record Book): diesel / gasoil / gas oil / MGO / DMA -> MGO (marine gas oil);
// MDO (marine diesel oil, DMB) only when it is said. Same rule as hc_fuel_grade() in sql/test-fixes-1.sql (tested together).
export const FUELS = [['MGO', 'MGO - marine gas oil (diesel, gasoil, DMA)'], ['MDO', 'MDO - marine diesel oil (DMB)'], ['ULSD', 'ULSD - ultra low sulphur diesel'], ['HVO', 'HVO'], ['Gasoline', 'Gasoline'], ['Other', 'Other']]
export function fuelGrade(p) {
  if (p == null) return p
  const s = String(p).trim(), l = s.toLowerCase()
  if (!s) return p
  if (/\b(mdo|dmb)\b/.test(l) || /marine diesel oil/.test(l)) return 'MDO'
  if (/\bulsd\b/.test(l) || /ultra[ -]?low[ -]?sul(ph|f)ur diesel/.test(l)) return 'ULSD'
  if (/\bhvo\b/.test(l)) return 'HVO'
  if (/\b(gasoline|petrol)\b/.test(l)) return 'Gasoline'
  if (/\b(mgo|dma|dmz|gas ?oil|diesel)\b/.test(l) || /marine gas ?oil/.test(l)) return 'MGO'
  if (l === 'other') return 'Other'
  return s
}
// MDO only when the user (or the delivery note photo) said it: a model that turns "diesel" into MDO is corrected to MGO
export function fuelFromRequest(product, said, fromPhoto) {
  const g = fuelGrade(product) || 'MGO'
  if (g === 'MDO' && !fromPhoto && !/\b(mdo|dmb)\b|marine diesel oil/i.test(String(said || ''))) return 'MGO'
  return g
}

export function madeLines(b, lineLabel) {
  const out = []
  if (!b || !b.date) return out
  if (b.budget_line_id && b.post_budget !== false && b.total_cost != null) out.push('Budget' + (lineLabel ? ' ' + lineLabel : '') + ': +' + num(b.total_cost))
  else if (b.post_budget !== false && b.total_cost != null) out.push('Budget: no Fuel line for ' + String(b.date).slice(0, 4) + ' - not posted')
  if (b.document_id) out.push('Delivery note filed in Documents (type Bunkering, keep until ' + addDays(b.date, 3 * 365 + 1) + ')')
  if (b.orb_id) out.push('Oil Record Book: H 26 draft entry (sign it on the Oil Record Book page)')
  if (b.todo_item_id) out.push('To Do: retain the fuel sample until ' + addDays(b.date, 365))
  if (b.engine_log_id) out.push('Engine room log ' + b.date + ': bunkering noted' + (b.fuel_after_l != null ? ', fuel total ' + b.fuel_after_l + ' L' : ''))
  if (b.diary_id) out.push('Diary: bunkering entry')
  return out
}

// Deleting a bunkering (sql/test-fixes-6.sql hc_bunkering_links DELETE): the database removes exactly the records whose ids the
// row stores; a SIGNED Oil Record Book entry blocks the delete. Same words for the page confirm, the AI card and the database.
export const orbSigned = o => !!o && !!(o.signed_at || String(o.signed_by || '').trim() || o.master_signed_at || String(o.master_signed_by || '').trim())
export const signedOrbMessage = date => 'This bunkering cannot be deleted: its Oil Record Book entry (H 26, ' + String(date || '').slice(0, 10) + ') is already signed. ' +
  'A signed entry stays in the Oil Record Book - record a correction there instead. Nothing was deleted.'
export function removedLines(b) {
  const out = []
  if (!b) return out
  if (b.budget_line_id && b.post_budget !== false && b.total_cost != null && b.db_links !== false) out.push('Budget: ' + num(b.total_cost) + ' taken back off the Fuel line')
  if (b.document_id) out.push('Delivery note in Documents')
  if (b.orb_id) out.push('Oil Record Book: the unsigned H 26 draft')
  if (b.todo_item_id) out.push('To Do: retain the fuel sample')
  if (b.engine_log_id) out.push('Engine room log ' + String(b.date).slice(0, 10) + ': the bunkering note line')
  if (b.diary_id) out.push('Diary: the bunkering entry')
  return out
}
